import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute, GuestRoute } from './guards';
import MainLayout from '@/components/layout/MainLayout';
import AuthLayout from '@/components/layout/AuthLayout';
import AdminLayout from '@/components/layout/AdminLayout';
import ManageLayout from '@/components/layout/ManageLayout';
import { ScrollToTop } from '@/components/common';

// Pages
import HomePage from '@/pages/home/HomePage';
import LoginPage from '@/pages/auth/LoginPage';
import RegisterPage from '@/pages/auth/RegisterPage';
import ProfilePage from '@/pages/user/ProfilePage';
import CandidateProfilePage from '@/pages/user/CandidateProfilePage';
import UserAnalyticsPage from '@/pages/user/UserAnalyticsPage';
import UserManagePostsPage from '@/pages/user/UserManagePostsPage';

// Services
import TuVanPhapLyPage from '@/pages/services/TuVanPhapLyPage';
import DichVuHoTroATFPPage from '@/pages/services/DichVuHoTroATFPPage';
import HoTroKeToanPage from '@/pages/services/HoTroKeToanPage';
import DatHangNguyenLieuPage from '@/pages/services/DatHangNguyenLieuPage';
import CacDichVuKhacPage from '@/pages/services/CacDichVuKhacPage';
import HoiVienPage from '@/pages/services/HoiVienPage';
import KhaoSatChuoiPage from '@/pages/services/KhaoSatChuoiPage';
import DangKyHoiVienPage from '@/pages/services/DangKyHoiVienPage';
import KhaoSatCuaHangPage from '@/pages/services/KhaoSatCuaHangPage';
import TaiLieuBaoCaoPage from '@/pages/services/TaiLieuBaoCaoPage';
import TrungTamHoTroPage from '@/pages/services/TrungTamHoTroPage';

// Transfer
import TransferListPage from '@/pages/transfer/TransferListPage';
import TransferDetailPage from '@/pages/transfer/TransferDetailPage';
import CreateTransferPage from '@/pages/transfer/CreateTransferPage';
import SavedTransfersPage from '@/pages/transfer/SavedTransfersPage';
import OfferedTransfersPage from '@/pages/transfer/OfferedTransfersPage';
import SellerManageTransfersPage from '@/pages/transfer/Manage/SellerManageTransfersPage';
import TransferRequestListPage from '@/pages/transfer/TransferRequestListPage';
import TransferRequestDetailPage from '@/pages/transfer/TransferRequestDetailPage';
import CreateTransferRequestPage from '@/pages/transfer/CreateTransferRequestPage';
import SavedTransferRequestsPage from '@/pages/transfer/SavedTransferRequestsPage';
import OfferedTransferRequestsPage from '@/pages/transfer/OfferedTransferRequestsPage';
import CompanyListPage from '@/pages/company/CompanyListPage';
import CompanyDetailPage from '@/pages/company/CompanyDetailPage';

// Job
import JobListPage from '@/pages/jobs/JobListPage';
import JobDetailPage from '@/pages/jobs/JobDetailPage';
import CreateJobPage from '@/pages/jobs/CreateJobPage';
import AppliedJobsPage from '@/pages/jobs/AppliedJobsPage';
import SavedJobsPage from '@/pages/jobs/SavedJobsPage';
import RecruiterManageJobsPage from '@/pages/jobs/Manage/components/RecruiterManageJobsPage';
import EditJobPage from '@/pages/jobs/EditJobPage';
import SearchCandidatesPage from '@/pages/jobs/Manage/SearchCandidatesPage';

// Admin
import AdminDashboard from '@/pages/admin/AdminDashboard';
import AdminTransferPage from '@/pages/admin/AdminTransferPage';
import AdminUsersPage from '@/pages/admin/AdminUsersPage';
import NotFoundPage from '@/pages/NotFoundPage';
import ForbiddenPage from '@/pages/ForbiddenPage';

// Rental
import PropertyListPage from '@/pages/rental/PropertyListPage';
import RentalRequestListPage from '@/pages/rental/RentalRequestListPage';
import SavedRentalsPage from '@/pages/rental/SavedRentalsPage';
import OfferedRentalsPage from '@/pages/rental/OfferedRentalsPage';
import RentalRequestDetailPage from '@/pages/rental/RentalRequestDetailPage';
import CreateRentalRequestPage from '@/pages/rental/CreateRentalRequestPage';
import SavedRentalRequestsPage from '@/pages/rental/SavedRentalRequestsPage';
import OfferedRentalRequestsPage from '@/pages/rental/OfferedRentalRequestsPage';

// Franchise
import FranchiseListPage from '@/pages/franchise/FranchiseListPage';
import FranchiseDetailPage from '@/pages/franchise/FranchiseDetailPage';
import CreateFranchisePage from '@/pages/franchise/CreateFranchisePage';
import SavedFranchisesPage from '@/pages/franchise/SavedFranchisesPage';
import OfferedFranchisesPage from '@/pages/franchise/OfferedFranchisesPage';

import FranchiseRequestListPage from '@/pages/franchise/FranchiseRequestListPage';
import FranchiseRequestDetailPage from '@/pages/franchise/FranchiseRequestDetailPage';
import CreateFranchiseRequestPage from '@/pages/franchise/CreateFranchiseRequestPage';
import SavedFranchiseRequestsPage from '@/pages/franchise/SavedFranchiseRequestsPage';
import OfferedFranchiseRequestsPage from '@/pages/franchise/OfferedFranchiseRequestsPage';

import CreateRentalPage from '@/pages/rental/CreateRentalPage';
import RentalDetailPage from '@/pages/rental/RentalDetailPage';

// Chat
import ChatPage from '@/pages/chat/ChatPage';

export default function AppRouter() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        {/* ── Guest only ── */}
        <Route element={<GuestRoute />}>
          <Route element={<AuthLayout />}>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />

          </Route>
        </Route>

        {/* ══ Admin routes ══ */}
        {/* <Route element={<AdminRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="/admin" element={<AdminDashboard />} />
            <Route path="/admin/sang-nhuong" element={<AdminTransferPage />} />
            <Route path="/admin/viec-lam" element={<JobListPage />} />
            <Route path="/admin/users" element={<AdminUsersPage />} />
          </Route>
        </Route> */}

        <Route element={<MainLayout />}>
          {/* ── Public Browsing Routes ── */}
          <Route path="/" element={<HomePage />} />

          {/* sang nhuong */}
          <Route path="/sang-nhuong" element={<TransferListPage />} />
          <Route path="/sang-nhuong/:id" element={<TransferDetailPage />} />
          <Route path="/nhu-cau-sang-nhuong" element={<TransferRequestListPage />} />
          <Route path="/nhu-cau-sang-nhuong/:id" element={<TransferRequestDetailPage />} />

          {/* rental */}
          <Route path="/cho-thue" element={<PropertyListPage />} />
          <Route path="/cho-thue/:id" element={<RentalDetailPage />} />
          <Route path="/nhu-cau-cho-thue" element={<RentalRequestListPage />} />
          <Route path="/nhu-cau-cho-thue/:id" element={<RentalRequestDetailPage />} />

          {/* job */}
          <Route path="/viec-lam" element={<JobListPage />} />
          <Route path="/viec-lam/:id" element={<JobDetailPage />} />

          {/* franchise */}
          <Route path="/nhuong-quyen" element={<FranchiseListPage />} />
          <Route path="/nhuong-quyen/:id" element={<FranchiseDetailPage />} />
          <Route path="/nhu-cau-nhuong-quyen" element={<FranchiseRequestListPage />} />
          <Route path="/nhu-cau-nhuong-quyen/:id" element={<FranchiseRequestDetailPage />} />

          {/* company */}
          <Route path="/cong-ty" element={<CompanyListPage />} />
          <Route path="/cong-ty/:id" element={<CompanyDetailPage />} />

          {/* services */}
          <Route path="/dich-vu/khac" element={<CacDichVuKhacPage />} />
          <Route path="/dich-vu/tu-van-phap-ly" element={<TuVanPhapLyPage />} />
          <Route path="/dich-vu/atfp" element={<DichVuHoTroATFPPage />} />
          <Route path="/dich-vu/ke-toan" element={<HoTroKeToanPage />} />
          <Route path="/dich-vu/nguyen-lieu" element={<DatHangNguyenLieuPage />} />
          <Route path="/dich-vu/hoi-vien" element={<HoiVienPage />} />
          <Route path="/dich-vu/khao-sat-chuoi" element={<KhaoSatChuoiPage />} />
          <Route path="/dich-vu/dang-ky-hoi-vien" element={<DangKyHoiVienPage />} />
          <Route path="/dich-vu/khao-sat-cua-hang" element={<KhaoSatCuaHangPage />} />
          <Route path="/dich-vu/tai-lieu" element={<TaiLieuBaoCaoPage />} />
          <Route path="/dich-vu/ho-tro" element={<TrungTamHoTroPage />} />

          {/* ── Protected Routes (Require Authentication) ── */}
          <Route element={<ProtectedRoute />}>
            <Route path="/ho-so" element={<ProfilePage />} />
            <Route path="/ho-so-ung-vien" element={<CandidateProfilePage />} />
            <Route path="/user/analytics" element={<UserAnalyticsPage />} />
            <Route path="/user/tin-dang" element={<UserManagePostsPage />} />

            <Route path="/nhuong-quyen/da-luu" element={<SavedFranchisesPage />} />
            <Route path="/nhu-cau-nhuong-quyen/da-luu" element={<SavedFranchiseRequestsPage />} />

            <Route path="/tin-nhan" element={<ChatPage />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={['admin', 'restaurantseller']} />}>
            {/* Seller functions */}
            <Route path="/sang-nhuong/tao-tin" element={<CreateTransferPage />} />
            <Route path="/sang-nhuong/sua/:id" element={<CreateTransferPage />} />

            <Route path="/nhu-cau-sang-nhuong/da-luu" element={<SavedTransferRequestsPage />} />
            <Route path="/nhu-cau-sang-nhuong/da-de-nghi" element={<OfferedTransferRequestsPage />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={['admin', 'restaurantbuyer']} />}>
            {/* Buyer functions */}
            <Route path="/nhu-cau-sang-nhuong/tao-tin" element={<CreateTransferRequestPage />} />
            <Route path="/nhu-cau-sang-nhuong/sua/:id" element={<CreateTransferRequestPage />} />

            <Route path="/sang-nhuong/da-luu" element={<SavedTransfersPage />} />
            <Route path="/sang-nhuong/da-de-nghi" element={<OfferedTransfersPage />} />
          </Route>


          <Route element={<ProtectedRoute allowedRoles={['admin', 'franchiser']} />}>
            <Route path="/nhuong-quyen/tao-tin" element={<CreateFranchisePage />} />
            <Route path="/nhuong-quyen/sua/:id" element={<CreateFranchisePage />} />
            <Route path="/nhu-cau-nhuong-quyen/da-luu" element={<SavedFranchiseRequestsPage />} />
            <Route path="/nhu-cau-nhuong-quyen/da-de-nghi" element={<OfferedFranchiseRequestsPage />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={['admin', 'franchiseseeker']} />}>
            <Route path="/nhu-cau-nhuong-quyen/tao-tin" element={<CreateFranchiseRequestPage />} />
            <Route path="/nhu-cau-nhuong-quyen/sua/:id" element={<CreateFranchiseRequestPage />} />

            <Route path="/nhuong-quyen/da-luu" element={<SavedFranchisesPage />} />
            <Route path="/nhuong-quyen/da-de-nghi" element={<OfferedFranchisesPage />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={['admin', 'headhunter', 'headhunterclient']} />}>
            <Route path="/viec-lam/dang-tuyen" element={<CreateJobPage />} />
            <Route path="/viec-lam/sua/:id" element={<EditJobPage />} />
            <Route path="/ung-vien/tim-kiem" element={<SearchCandidatesPage />} />
          </Route>
          <Route element={<ProtectedRoute allowedRoles={['admin', 'jobseeker']} />}>
            <Route path="/viec-lam/da-ung-tuyen" element={<AppliedJobsPage />} />
            <Route path="/viec-lam/da-luu" element={<SavedJobsPage />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={['admin', 'landlord']} />}>
            <Route path="/cho-thue/tao-tin" element={<CreateRentalPage />} />
            <Route path="/cho-thue/sua/:id" element={<CreateRentalPage />} />

            <Route path="/nhu-cau-cho-thue/da-luu" element={<SavedRentalRequestsPage />} />
            <Route path="/nhu-cau-cho-thue/da-de-nghi" element={<OfferedRentalRequestsPage />} />
          </Route>

          <Route element={<ProtectedRoute allowedRoles={['admin', 'propertyseeker']} />}>
            <Route path="/nhu-cau-cho-thue/tao-tin" element={<CreateRentalRequestPage />} />
            <Route path="/nhu-cau-cho-thue/sua/:id" element={<CreateRentalRequestPage />} />

            <Route path="/cho-thue/da-luu" element={<SavedRentalsPage />} />
            <Route path="/cho-thue/da-de-nghi" element={<OfferedRentalsPage />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['admin', 'headhunter', 'headhunterclient']} />}>
          <Route element={<ManageLayout />}>
            <Route path="/viec-lam/quan-ly/*" element={<RecruiterManageJobsPage />} />
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['admin', 'restaurantseller']} />}>
          <Route element={<ManageLayout />}>
            <Route path="/sang-nhuong/quan-ly/*" element={<SellerManageTransfersPage />} />
          </Route>
        </Route>

        {/* ── 403 ── */}
        <Route path="/forbidden" element={<ForbiddenPage />} />

        {/* ── 404 ── */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
